export default {
    // compartido
    bs_save: "Guardar",
    bs_cancel: "Cancelar",
    bs_error: "Error",
    bs_failed: "Error",
    bs_on: "On",
    bs_off: "Off",
    bs_total: "Total",
    bs_tax: "Impuesto",
    bs_name: "Nombre",
    bs_status: "Estado",
    bs_edit: "Editar",
    bs_delete: "Eliminar",
    bs_phone: "Teléfono",
    bs_email: "Correo",
    bs_title_label: "Título",
    bs_description: "Descripción",
    bs_price: "Precio",
    bs_active: "Activo",
    bs_inactive: "Inactivo",
    bs_products: "Productos",
    bs_subtotal: "Subtotal",
    bs_discount: "Descuento",
    bs_delivery_fee: "Tarifa de Envío",
    bs_notes: "Notas",
    bs_could_not_save: "No se pudo guardar.",
    bs_swal_delete_title: "¿Eliminar ítem?",
    bs_swal_text: "¿Estás seguro?",
    bs_swal_confirm: "¡Sí, elimínalo!",
    bs_success: "Éxito",

    // productCategory
    bscat_category_name_ph: "Nombre de Categoría",

    // productEditDescription
    bsed_add_description_ph: "Agregar descripción",

    // productEditName
    bsen_add_name_ph: "Agregar nombre del producto",

    // OrderForm
    bsof_edit_order: "Editar Pedido",
    bsof_create_order: "Crear Pedido",
    bsof_first_name: "Nombre",
    bsof_first_name_ph: "Juan",
    bsof_last_name: "Apellido",
    bsof_last_name_ph: "García",
    bsof_phone_ph: "+123456789",
    bsof_email_ph: "juan@ejemplo.com",
    bsof_order_source: "Origen del pedido",
    bsof_source_cart: "Carrito",
    bsof_source_manual: "Manual",
    bsof_source_whatsapp: "whatsapp",
    bsof_notes_ph: "Agregar notas...",
    bsof_discount_label: "Descuento %",

    // OrderItemsTable
    bsoit_product_service: "Producto / Servicio",
    bsoit_qty: "Cant.",
    bsoit_choose_product_ph: "Elegir un Producto",
    bsoit_product_note_ph: "Nota del producto:",
    bsoit_add_product: "+ Producto",
    bsoit_none: "Ninguno",

    // tableOrders
    bsto_order: "Pedido",
    bsto_customer_name: "Nombre del Cliente",
    bsto_source: "Origen",
    bsto_items: "Ítems",
    bsto_payment: "Pago",
    bsto_in_progress: "En Progreso",
    bsto_pending: "Pendiente",
    bsto_paid: "Pagado",
    bsto_unpaid: "Sin Pagar",
    bsto_declined: "Rechazado",
    bsto_in_transit: "En Tránsito",
    bsto_out_for_delivery: "En Camino",
    bsto_ready_for_pickup: "Listo para Recoger",
    bsto_picked_up: "Recogido",
    bsto_processing: "Procesando",
    bsto_shipped: "Enviado",
    bsto_delivered: "Entregado",
    bsto_cancelled: "Cancelado",
    bsto_order_details: "Detalles del Pedido",

    // bStore_orders
    bsord_add_order: "Agregar Pedido",
    bsord_search_ph: "Buscar pedidos...",
    bsord_item_required: "El pedido debe tener al menos un ítem.",

    // bStore_products
    bsprod_remove_category_error: "Para eliminarla no debe tener productos",
    bsprod_swal_delete_prefix: "Eliminar",

    // btns_cart
    bsbtn_add_to_cart: "Agregar al carrito",
    bsbtn_contact: "Contacto",

    // optsPrice / productEditPrice
    bsop_qty_selector: "Cantidad:",
    bsop_price_type: "Tipo de precio",
    bsop_fixed: "fijo",
    bsop_variable: "variable",
    bsop_contact: "contacto",
    bsop_sell_status: "Estado de Venta",
    bsop_available: "disponible",
    bsop_showcase: "exhibición",
    bsop_sold_out: "agotado",
    bsop_visibility: "Visibilidad",
    bsop_amount: "Monto",
    bsop_amount_ph: "Ej. 1.00",
    bsop_discount_ph: "Ej. 10%",
    bsop_final_price: "Precio Final",
    bsop_hidden_product: "Producto Oculto",
    bsop_hidden_price: "Precio Oculto",
    bsop_from: "Desde",
    bsop_wrong_format: "Error, formato incorrecto, máximo 2 decimales.",
    bsop_incorrect_amount: "Monto incorrecto.",

    // productList
    bspl_new_item: "+ Nuevo Ítem",
    bspl_product_name_ph: "nombre del producto",

    // productSlider
    bssl_delete_product: "Eliminar producto",

    // bStore_setup_booking
    bssb_booking_calendar: "Calendario de reservas:",
    bssb_show_dates: "Mostrar fechas disponibles",
    bssb_schedule: "Horario:",
    bssb_show_times: "Mostrar horas disponibles",
    bssb_instructions: "Instrucciones:",
    bssb_instructions_ph: "Ingresa instrucciones especiales para los clientes...",

    // bStore_setup_categories
    bssc_edit_currency: "Editar Moneda:",
    bssc_usd: "$ USD",
    bssc_pen: "S./ Sol PEN",
    bssc_add_new: "Agregar nuevo:",
    bssc_category_name_ph: "Nombre de categoría",
    bssc_no_record: "Sin registros",
    bssc_delete_title: "¿Eliminar ítem?",

    // bStore_setup_order
    bsso_tax_label: "Impuesto:",
    bsso_delivery_fee_label: "Tarifa de Envío:",
    bsso_privacy_link: "Enlace Privacidad y Política:",
    bsso_terms_link: "Enlace Términos y Condiciones:",
    bsso_return_link: "Enlace Política de Devolución:",

    // bsite_bStore_deals
    bsdl_title_ph: "Título de ofertas",
    bsdl_exclusive_offers: "Ofertas y descuentos exclusivos disponibles hoy. Promociones por tiempo limitado.",
    bsdl_title_section: "Título",
    bsdl_desc_optional: "Descripción: (Opcional)",
    bsdl_add_deal: "Agregar Oferta",
    bsdl_new_deal: "Nueva Oferta",
    bsdl_edit_deal: "Editar Oferta",
    bsdl_deal_title_ph: "Título de la oferta",
    bsdl_optional_label: "(Opcional)",
    bsdl_upload_image: "Subir imagen",
    bsdl_enable_message: "Activa las Ofertas del Día para gestionar promociones diarias.",
    bsdl_title_required: "El título debe tener al menos 3 caracteres.",
    bsdl_today_deals: "Ofertas del Día",
    bsdl_failed_save_title: "Error al guardar el título.",
    bsdl_failed_save_content: "Error al guardar el contenido.",
    bsdl_failed_save_deal: "Error al guardar la oferta.",
    bsdl_failed_delete_deal: "Error al eliminar la oferta.",
    bsdl_failed_save_deals: "Error al guardar las ofertas.",
    bsdl_delete_deal: "¿Eliminar Oferta?",

    // bStore_setup (tab menu)
    bssu_setup_title: "Configurar bStore",
    bssu_categories: "Categorías",
    bssu_orders: "Pedidos",
    bssu_booking: "Reservas",
    bssu_notifications: "Notificaciones",

    // bStore_setup_noti
    bssn_whatsapp: "WhatsApp",
    bssn_contact_btn_text: "Texto del botón de contacto",
    bssn_auto_response: "Respuesta Automática",
    bssn_sms: "SMS",
    bssn_send_response: "Enviar respuesta al cliente",
    bssn_default_contact: "Contacto",
    bssn_default_ws_msg: "Me interesa el producto: *{{product_name}}* de tu tienda.",

    // productUpload
    bspu_gallery: "Galería del Producto:",
    bspu_cover_image: "Imagen de Portada: (requerida)",
    bspu_add_image: "agregar imagen",
    bspu_upload_error: "No se pudo subir el archivo.",
    bspu_to_remove_items: "Para eliminarlo no debe tener ítems",
    bspu_could_not_delete: "No se pudo eliminar.",
}
